import Vue from 'vue'
import { ToastPlugin, ModalPlugin, BootstrapVue } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import mdiVue from 'mdi-vue/v2'
import * as mdijs from '@mdi/js'
import http from '@axios'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'

Vue.use(mdiVue, {
  icons: mdijs,
})

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

// Composition API
{
  const [major, minor] = Vue.version.split('.').map(Number)
  // Vue 2.7+ has built-in Composition API; plugin is only needed for Vue 2.6.
  if (major === 2 && minor < 7) {
    Vue.use(VueCompositionAPI)
  }
}

// Global Mixin
Vue.mixin({
  computed: {
    swedishLang() {
      return this.defaultLang == 'sv'
    },
    defaultLang() {
      return localStorage.getItem('lang')
    },
  },
})

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false
// Ensure CSRF cookie is initialized (noop if already set)
http.get('auth/csrf').catch(() => {})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
